import generateVersionHash from '@utils/generateVersionHash';
import { postApi } from '@/lib/fetcher';
import { date } from '@/lib/helpers';

const URL_API = '/index.php?r=api/v1/bcko_branch/bcko-branch/search';

const bckoSharedStore = {
  namespaced: true,
  state: {
    loading: false,
  },
  mutations: {
    setLoading(state, loading) {
      state.loading = loading;
    },
  },
  actions: {
    async getBcko(ctx, payload = {}) {
      const {
        page = 1,
        limit = 10,
        showAll = true,
        keyword = '',
      } = payload;

      const normalizedKeyword = typeof keyword === 'string' ? keyword.trim() : '';

      const data = JSON.stringify({
        page: String(page),
        limit: String(limit),
        show_all: showAll,
        keyword: normalizedKeyword,
        version: generateVersionHash(
          limit.toString() + page.toString(),
          date
        ),
      });

      try {
        ctx.commit('setLoading', true);

        const responseData = await postApi(ctx, URL_API, data);

        if (responseData?.code === 200) {
          const list = responseData?.data?.list || [];
          const total = responseData?.data?.countdata || list.length;

          return {
            success: true,
            data: list,
            total,
            response: responseData,
          };
        }

        return {
          success: false,
          message: responseData?.message_id || 'Failed to get BKCO data',
          data: [],
          total: 0,
        };
      } catch (error) {
        return {
          success: false,
          message: error.message,
          data: [],
          total: 0,
        };
      } finally {
        ctx.commit('setLoading', false);
      }
    },
  },
};

export default bckoSharedStore;
